import * as RadixSelect from '@radix-ui/react-select';
import styled, { css } from 'styled-components';

// A span, not a p: the page mixin's `.page-content p` line height (specificity 0,2,1) would win over this class.
export const FieldTitle = styled.span(
  ({ theme }) => css`
    display: block;
    font-size: ${theme.typography.bodySmall.fontSize};
    font-weight: ${theme.typography.bodySmall.fontWeight};
    line-height: ${theme.typography.bodySmall.lineHeight};
    letter-spacing: ${theme.typography.bodySmall.letterSpacing};
    color: ${theme.neutralTextWeak};
  `,
);
export const SelectTrigger = styled(RadixSelect.Trigger)(
  ({ theme }) => css`
    width: 274px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    cursor: pointer;
    background-color: ${theme.neutralBackground};
    border: 1px solid ${theme.neutralBorder};
    /* A <button> does not inherit color: without this the titled trigger's value, which sits
       below the title container rather than directly in the trigger, renders browser black. */
    color: ${theme.neutralText};
    padding: ${theme.fontSizes.xs} 10px;
    border-radius: 6px;
    height: 40px;

    > .select-selected-option {
      width: 100%;
      display: flex;
      align-items: center;
      font-size: ${theme.fontSizes.sm};
      line-height: ${theme.lineHeights.sm};
      color: ${theme.neutralTextWeak};
      font-weight: 400;
    }

    .select-icon {
      display: flex;
      align-items: center;
      position: relative;

      &::before {
        content: '';
        display: block;
        width: 1px;
        height: ${theme.fontSizes.base};
        background-color: ${theme.neutralBorder};
        position: absolute;
        left: -8px;
      }
    }
  `,
);

export const SelectTriggerWithTitleContainer = styled.div`
  display: flex;
  align-items: start;
  flex-direction: column;
`;

export const SelectContent = styled(RadixSelect.Content)<{ paddingZero?: boolean }>(
  ({ theme, paddingZero }) => css`
    background-color: ${theme.neutralBackgroundBase};
    padding: 8px;
    width: 240px;
    border: 1px solid ${theme.neutralBorder};
    box-shadow: 0 4px 17px 0 #0c1d3126; /* tokens-allow: pending design decision */
    border-radius: 6px;
    margin-top: 12px;

    > [role='option'] {
      font-weight: 400;
      color: ${theme.neutralText};
      font-size: ${theme.fontSizes.sm};
      line-height: ${theme.lineHeights.sm};
      padding: ${paddingZero ? '0px' : '8px 4px'};
      display: flex;
      align-items: center;
      cursor: pointer;
      border-radius: 4px;

      &[data-state='checked'] {
        background-color: ${theme.neutralBackground};
        font-weight: 500;
      }

      &:hover {
        background-color: ${theme.neutralBackground};
      }

      &[data-plain] {
        cursor: default;

        &:hover,
        &[data-highlighted],
        &[data-state='checked'] {
          background-color: transparent;
        }

        &[data-state='checked'] {
          font-weight: 400;
        }
      }
    }

    &[data-input-modality='pointer'] > [role='option'][data-plain]:focus-visible {
      outline: none;
    }
  `,
);
